import { useEffect } from "react";
import { CheckCircle2, Send } from "lucide-react";
import { TELEGRAM_URL } from "@/lib/telegram";

export default function ThankYouPage() {
  useEffect(() => {
    const meta = document.querySelector('meta[name="robots"]');
    const prevContent = meta ? meta.getAttribute("content") : null;
    const prevTitle = document.title;

    if (meta) {
      meta.setAttribute("content", "noindex, nofollow");
    }
    document.title = "Grazie — The Gold FX";

    return () => {
      if (meta && prevContent) meta.setAttribute("content", prevContent);
      document.title = prevTitle;
    };
  }, []);

  return (
    <div
      data-testid="thank-you-page"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#050505] px-4 py-16 font-body text-white sm:px-6"
    >
      <div className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute inset-0 bg-grid-pattern opacity-30" />
        <div
          className="absolute -left-40 -top-40 h-[500px] w-[500px] rounded-full opacity-30 blur-[120px] animate-float-slow"
          style={{
            background: "radial-gradient(circle, rgba(255,215,0,0.6) 0%, transparent 70%)",
          }}
        />
        <div
          className="absolute -right-40 bottom-40 h-[500px] w-[500px] rounded-full opacity-25 blur-[120px] animate-float-slow"
          style={{
            background: "radial-gradient(circle, rgba(0,240,255,0.55) 0%, transparent 70%)",
            animationDelay: "3s",
          }}
        />
      </div>

      <div
        data-testid="thank-you-card"
        className="relative z-10 w-full max-w-lg animate-fade-up rounded-[32px] border border-yellow-400/25 bg-[#0a0a0a]/90 p-8 text-center backdrop-blur-xl sm:p-12"
        style={{ boxShadow: "0 0 60px rgba(255,215,0,0.15)" }}
      >
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-green-400/40 bg-green-400/10 animate-pulse-glow">
          <CheckCircle2 className="h-8 w-8 text-green-400" data-testid="thank-you-check-icon" />
        </div>

        <h1
          data-testid="thank-you-title"
          className="mt-6 font-heading text-2xl font-black uppercase leading-tight tracking-tight text-white sm:text-3xl"
        >
          Complimenti! La tua <span className="text-gradient-gold">guida</span> è in arrivo
        </h1>
        <p data-testid="thank-you-subtitle" className="mt-3 font-body text-sm text-gray-400 sm:text-base">
          Riceverai la guida all&apos;indirizzo email che hai indicato. Controlla la tua casella
          di posta (anche nello spam) nei prossimi minuti.
        </p>

        <div className="my-8 h-px w-full bg-gradient-to-r from-transparent via-white/15 to-transparent" />

        <div data-testid="thank-you-step-two">
          <span className="font-heading text-xs font-bold uppercase tracking-[0.25em] text-cyan-300">
            Ora fai l&apos;ultimo passo
          </span>
          <p className="mt-3 font-body text-sm text-gray-300 sm:text-base">
            Accedi subito alla community Telegram ufficiale per iniziare il collegamento guidato
            con Aurum AI.
          </p>

          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="thank-you-telegram-cta"
            className="group mt-6 inline-flex w-full items-center justify-center gap-3 rounded-full bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-600 px-8 py-5 font-heading text-base font-black uppercase tracking-wider text-black shadow-[0_0_40px_rgba(255,215,0,0.5)] transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_60px_rgba(255,215,0,0.75)]"
          >
            <Send className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            Accedi al canale
          </a>
          <p data-testid="thank-you-hint" className="mt-3 font-body text-xs text-gray-500">
            Trovi le istruzioni complete nel messaggio fissato in cima al canale.
          </p>
        </div>
      </div>
    </div>
  );
}
